import { EnvironmentConfig } from "../utilities/interfaces/environment.interface";

export const environment: EnvironmentConfig = {
  production: false,
  webdomain: "https://pictrackdev.cloud.delega.co/",
  api: "/api",
  showTestLabels: true
};
 